import * as React from "react";
import "./favouriteItem.scss"
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import IconSmall from "../../../../hiberUiKit/src/atoms/Icon/IconSmall";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import DropDownList, {DropDownItem} from "../../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import {isDefined} from "../../../../utils/Utils";
import SearchDropDown from "../../../../hiberUiKit/src/molecules/SearchDropDown/SearchDropDown";
import {WorkspaceView} from "../../../../model/workspace/WorkspaceView";
import classNames = require("classnames");

interface IProps {
	index?: number;
	item?: FavouriteItemProps;
	onViewClick?: (id: string) => void;
	onOrderChange?: (dragged: number, target: number) => void;
	views?: WorkspaceView[];
	onAddToFavourites?: (viewId: string) => void;
}

interface IState {
	menuDropDownVisible: boolean;
	viewsDropDownVisible: boolean;
}

const DATA_TYPE = "dragged_favourite_item";

export default class FavouriteItem extends React.Component<IProps, IState> {
	menu = [
		{id: "l1", label: "Rename"},
		{id: "l2", label: "Remove from favourites"}
	];

	constructor(props: IProps) {
		super(props);

		this.state = {menuDropDownVisible: false, viewsDropDownVisible: false};

		this.onMenuItemSelect = this.onMenuItemSelect.bind(this);
		this.onAddToFavourites = this.onAddToFavourites.bind(this);
	}

	render() {
		const classes = classNames({
			"c-favourite-item": true,
			"reset-dropdown-right": true,
			"is-empty": !this.props.item,
			"is-selected": this.props.item && this.props.item.isSelected,
			"is-focused": this.state.menuDropDownVisible,
		});
		return (
			<div className={classes}
				 draggable={isDefined(this.props.item)}
				 onDragOver={(ev) => {
					 isDefined(this.props.item)
					 && ev.nativeEvent.dataTransfer.types.indexOf(DATA_TYPE) > -1
					 && ev.preventDefault()
				 }}
				 onDragStart={(ev) => ev.dataTransfer.setData(DATA_TYPE, this.props.index.toString())}
				 onDrop={(ev) => {
					 const dragged = Number(ev.dataTransfer.getData(DATA_TYPE));
					 const target = this.props.index;
					 this.props.onOrderChange && dragged != target && this.props.onOrderChange(dragged, target);
				 }}
				 onClick={() => !isDefined(this.props.item) && this.setState({viewsDropDownVisible: true})}>
				{this.props.item ? this.renderFavouriteItem() : this.renderEmpty()}
				{this.state.menuDropDownVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({menuDropDownVisible: false})}>
					<DropDownList items={this.menu} itemToId={(link: DropDownItem) => link.id}
								  itemToLabel={(link: DropDownItem) => link.label}
								  itemDisabled={() => false}
								  onSelect={this.onMenuItemSelect}/>
				</DropDownWrapper>}
				{this.state.viewsDropDownVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({viewsDropDownVisible: false})}>
					<SearchDropDown items={this.props.views}
									itemToId={(item: WorkspaceView) => item.id}
									itemToLabel={(item: WorkspaceView) => item.name}
									onChange={this.onAddToFavourites}
					/>
				</DropDownWrapper>}
			</div>
		)
	}

	renderEmpty() {
		return <div>+ Add your favourite view</div>
	}

	renderFavouriteItem() {
		return (
			<React.Fragment>
				<div className={"c-favourite-item_content"}
					 onClick={() => this.props.onViewClick && this.props.onViewClick(this.props.item.id)}>
					<div>
						{this.props.item.name}
					</div>
					{/*<div className={"c-favourite-item_content_counter"}>{this.props.item.counter}</div>*/}
				</div>
				<div className={"c-favourite-item_menu"}
					 onClick={() => {this.setState({menuDropDownVisible: !this.state.menuDropDownVisible})}}>
					<IconSmall icon={Icon.Overflow}/>
				</div>
			</React.Fragment>
		)
	}

	onMenuItemSelect(item: DropDownItem) {
		this.setState({menuDropDownVisible: false});
		switch (item.id) {
			case "l1":
				this.props.item.onRename();
				break;
			case "l2":
				this.props.item.onRemove();
				break;
		}
	}

	onAddToFavourites(view: WorkspaceView) {
		this.setState({viewsDropDownVisible: false}, () => {this.props.onAddToFavourites(view.id) });
	}
}

export interface FavouriteItemProps {
	id: string;
	name: string;
	counter: number;
	isSelected: boolean;
	onRemove: () => void;
	onRename: () => void;
}
